// extracted by mini-css-extract-plugin
export default {"tupacGrid":"En-z","tupacHeader":"Fn-z","tupacHeader2":"Gn-z","tupacMenu":"Hn-z","tupacMenu2":"In-z","tupacMain":"Jn-z","tupacMain2":"Kn-z"};